import { render, staticRenderFns } from "./DragableTable.vue?vue&type=template&id=8e4c9238&scoped=true"
import script from "./DragableTable.vue?vue&type=script&lang=js"
export * from "./DragableTable.vue?vue&type=script&lang=js"
import style0 from "./DragableTable.vue?vue&type=style&index=0&id=8e4c9238&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4c9238",
  null
  
)

export default component.exports